import type * as Referrals from "../../lib/models/referrals.server.ts"

import { toSentenceCase, toTemplate } from "@iyk/string"
import { cva, Icon } from "@iyk/ui"
import { useLang } from "../../lib/lang/use-lang.ts"

export function ReferralAlert({ referral, className }: ReferralAlertProps) {
  const lang = useLang()
  if (referral.discountPercentageDecimal <= 0) return null
  return (
    <div className={classForReferralAlert({ className })}>
      <Icon.Sale />
      <p className="text-sm">
        {toSentenceCase(
          toTemplate(lang.terms.REFERRAL_ALERT_MESSAGE, {
            discountPercentage: referral.discountPercentageDecimal.toString(),
            referrer: referral.referrer.username,
          }),
        )}
      </p>
    </div>
  )
}

const classForReferralAlert = cva([
  "w-full",
  "px-3 py-2.5",
  "rounded-sm",
  "text-center text-gray-11",
  "bg-gray-2",
  "flex items-center gap-2",
])

type ReferralAlertProps = {
  referral: Referrals.ReferralData
  className?: string
}
